import type { AxiosResponse } from 'axios';

async function getInvoices(resellerDocument: string, params?: any) {
  return await get('invoices', { resellerDocument, ...params }).then(
    (response: AxiosResponse) => response,
    (error: any) => {
      throw error;
    },
  );
}

export async function listInvoices(resellerDocument: string) {
  return await getInvoices(resellerDocument).then(
    (response: AxiosResponse) => ({
      invoiceList: adaptInvoiceListFromAPI(response.data.data.items),
      pagination: response.data.data.pagination,
    }),
    (error: any) => {
      throw error;
    },
  );
}

export async function filterInvoices(
  resellerDocument: string,
  filters: IInvoiceFilters,
  pagination = { ...PAGINATION },
) {
  try {
    const params = adaptQueryParams<IInvoiceFilters, IInvoiceFilterParams>(
      filters,
      pagination,
      prepareInvoiceFilterQueryParams,
    );
    const response = await getInvoices(resellerDocument, params);

    return {
      invoiceList: adaptInvoiceListFromAPI(response.data.data.items),
      pagination: response.data.data.pagination,
    };
  } catch (error: any) {
    if (!(error instanceof Error) && isMySsException(error)) throw error;

    if (isValidMySsException(error.message)) throw JSON.parse(error.message);
  }
}

export async function listInvoiceStatement(orderNumber: string | number) {
  return await get(`invoices/${orderNumber}/statement`).then(
    (response: MySsApiResponse) => adaptOrderStatementListContent(response.data.data),
    (error: MySsException) => {
      throw error;
    },
  );
}

export async function listInvoicesDownload(resellerDocument: string, params?: any) {
  return await get('invoices/download', { resellerDocument, ...params }).then(
    (response: any) => response.data,
    (error: MySsException) => {
      throw error;
    },
  );
}
